<script lang="ts" setup>
import { DropdownDto } from "@/components/Dto/DropdownDto";
import { LogIn, CircleUser } from "lucide-vue-next";
import { motion } from "motion-v";

const user = localStorage.getItem("user");
</script>

<template>
    <header class="layout flex justify-between gap-2 xs:gap-0 px-3 xs:px-8 py-3 items-center min-w-full border-b"
        data-testid="Header">
        <motion.div :initial="{ scale: 0 }" :animate="{ scale: 1 }" :transition="{
            duration: 0.4,
            scale: { type: 'spring', visualDuration: 0.4, bounce: 0.5 }
        }" class="flex gap-4 items-center">
            <RouterLink to="/" class="hidden lg:flex hover:opacity-50" aria-label="Ir para página inicial">
                    <Image src="/logo.svg" alt="NEI Logo" width="150" height="53.69"
                        class="w-full h-full object-contain" />
            </RouterLink>
            <RouterLink to="/" class="flex lg:hidden hover:opacity-50" aria-label="Ir para página inicial">
                    <Image src="/logo-just-icon.webp" alt="NEI Logo" width="40" height="40"
                        class="w-full h-full object-contain" />
            </RouterLink>
            <div class="hidden lg:flex max-w-fit">
                <Dropdown buttonTile="Recursos ▼" label="Tópicos" :menu="DropdownDto" />
            </div>
            <RouterLink to="/news" class="hidden lg:flex">
                <Button v-translate variant="outline">
                    Notícias
                </Button>
            </RouterLink>
        </motion.div>
        <motion.div :initial="{ scale: 0 }" :animate="{ scale: 1 }" :transition="{
            duration: 0.4,
            scale: { type: 'spring', visualDuration: 0.4, bounce: 0.5 }
        }" class="justify-center w-full max-w-80">
            <SearchBarForCrypto v-if="$route.path.includes('/cryptos')" />
            <SearchBarForNews v-else-if="$route.path.includes('/news')" />
            <SearchBarForStocks v-else-if="$route.path.includes('/stocks')" />
            <SearchBarForNfts v-else-if="$route.path.includes('/nfts')" />
            <SearchBarForRoute v-else />
        </motion.div>
        <motion.div :initial="{ scale: 0 }" :animate="{ scale: 1 }" :transition="{
            duration: 0.4,
            scale: { type: 'spring', visualDuration: 0.4, bounce: 0.5 }
        }" class="justify-end flex gap-4 md:gap-6 lg:gap-8 items-center">
            <RouterLink v-if="!user" to="/login" aria-label="Fazer login na conta">
                <button class="flex lg:hidden border-border border hover:bg-buttonBg p-2 rounded-full"
                    aria-label="Fazer login">
                    <LogIn />
                </button>
                <Button v-translate class="hidden lg:flex">Conectar a Conta</Button>
            </RouterLink>
            <RouterLink v-else to="/user" aria-label="Acessar minha conta">
                <button class="flex lg:hidden border-border border hover:bg-buttonBg p-2 rounded-full"
                    aria-label="Acessar conta do usuário">
                    <CircleUser />
                </button>
                <Button v-translate class="hidden lg:flex">Minha Conta</Button>
            </RouterLink>
            <ToggleTheme variant="switch" />
        </motion.div>
    </header>
</template>

<style scoped>
@media (min-width: 600px) and (max-width: 1023px),
(min-width: 1400px) {
    div {
        @apply flex-1 flex;
    }
}
</style>
